import { create } from "zustand";
import { createContext, useContext, ReactElement, createElement } from "react";

type AiPanelStore = {
  enabled: boolean;
  open: boolean;
  toggle: () => void;
  setEnabled: (v: boolean) => void;
};

export const useAiPanelStore = create<AiPanelStore>((set) => ({
  enabled: false,
  open: false,
  toggle: () => set((s) => ({ open: !s.open })),
  setEnabled: (v: boolean) => set(() => ({ enabled: v })),
}));

// context provider (optional future expansion)
const AiPanelStoreContext = createContext<typeof useAiPanelStore | null>(null);

export function AiPanelStoreProvider({ children }: { children: React.ReactNode }): ReactElement {
  return createElement(
    AiPanelStoreContext.Provider,
    { value: useAiPanelStore },
    children
  );
}
